<template>
    <div class="font">
        <v-row class="extra-bottom-area">
            <v-col>
                <div class="stage-title">{{stage.Name && stage.Name.toUpperCase()}}</div>
                <v-form ref="form">
                    <div v-for="q in questions" :key="q.Id">
                        <apply-textarea
                            v-if="!q.Parent_Question__c && q.Type__c === 1"
                            :question="q.Question_Text__c"
                            :answer="q['Answer__c.Answer__c']"
                            :min_words="q.Min_words__c"
                            :max_words="q.Max_words__c"
                            :helper_text="q.Helper_Text__c"
                            :required="q['Required__c']"
                            :qid="q.Id"
                            @on-answer="updateAnswer"
                        ></apply-textarea>
                        <apply-checkbox
                            v-else-if="!q.Parent_Question__c && q.Type__c === 2"
                            :question="q.Question_Text__c"
                            :answer="q['Answer__c.Answer__c'] ? q['Answer__c.Answer__c'].split('|') : []"
                            :options="q.Options__c ? q.Options__c.split('|'): []"
                            :helper_text="q.Helper_Text__c"
                            :required="q['Required__c']"
                            :childQuestions="findChildQuestions(q)"
                            :qid="q.Id"
                            @on-answer="updateAnswer"
                        ></apply-checkbox>
                        <apply-radio
                            v-else-if="!q.Parent_Question__c && q.Type__c === 3"
                            :question="q.Question_Text__c"
                            :answer="q['Answer__c.Answer__c']"
                            :options="q.Options__c ? q.Options__c.split('|') : []"
                            :helper_text="q.Helper_Text__c"
                            :required="q['Required__c']"
                            :childQuestions="findChildQuestions(q)"
                            :qid="q.Id"
                            @on-answer="updateAnswer"
                        ></apply-radio>
                    </div>
                </v-form>
            </v-col>
        </v-row>
        <v-row class="sticky-footer" justify="center" align="center">
            <v-col cols="12" sm="3" md="3" lg="2">
                <v-btn class="button btn-font" outlined @click="$router.push({name: 'application.dashboard'})" color="#4d4d4d" large>BACK</v-btn>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="4">
                <v-btn class="button btn-font" :disabled="autoSaving" @click="save" color="#ea7f1d" large>{{autoSaving? 'AUTO SAVING...' : 'SAVE RESPONSES'}}</v-btn>
            </v-col>
        </v-row>
    </div>
</template>
<script>
// import StepMulti from "./StepMultiComponent";
// import StageBottomBar from './StageBottomBarComponent';
import ApplyTextarea from './ApplyTextareaComponent';
import ApplyCheckbox from './ApplyCheckboxComponent';
import ApplyRadio from './ApplyRadioComponent';
// import axios from 'axios'
import Client from '../client.js'

const AUTO_SAVE_INTERVAL = 30000;

export default {
    props: {
        stage_key: String,
        sort: [String, Number],
        application_id: [String, Number] 
    },
    components: {
        // StepMulti,
        // StageBottomBar,
        ApplyTextarea,
        ApplyCheckbox,
        ApplyRadio
    },
    computed: {
        stage() {
            const stages = this.$store.getters['stage/stages'];
            if(stages.length === 0) return {};
            return stages.find(s => s.Id === this.stage_key);
        },
        questions() {
            const questionsWithAnswer = this.$store.getters['stage/questionsWithAnswer'];
            if(!questionsWithAnswer[this.stage_key]) return [];
            return questionsWithAnswer[this.stage_key];
        },
    },
    data: function () {
        return {
            autoSaving: false
        }
    },
    mounted() {
        this.startAutoSave();
        this.initValidation();
    },
    beforeDestroy() {
        clearInterval(this.autoSaveTimer);
    },
    methods: {
        initValidation() {
            if(this.questions.length > 0) {
                if(this.stage.Status__c === 'In Progress') {
                    this.validate(true);
                }
            }
            this.validationTimer = setInterval(() => {
                if(this.questions.length > 0) {
                    clearInterval(this.validationTimer);
                    if(this.stage.Status__c === 'In Progress') {
                        this.validate(true);
                    }
                }
            }, 1000)
        },
        startAutoSave() {
            this.autoSaveTimer = setInterval(() => {
                this.autoSaving = true;
                const answers = this.questions;
                if(answers.length === 0) return;
                const status = this.validate() ? 'Completed' : 'In Progress';
                const client = Client();
                client.post(`/applications/${this.application_id}/stages/${this.stage_key}?status=${status}`, {
                    answers: answers.map(a => ({
                        Id: a['Answer__c.Id'],
                        Answer__c: a['Answer__c.Answer__c'],
                        Question__c: a.Id,
                        Scholarship_Application__c: this.application_id
                    }))
                }).then((res) => {
                    this.autoSaving = false
                    if(res.status === 200) {
                        // this.$store.dispatch('stage/fetchQuestionsWithAnswer', {stageId: this.stage_key, appId: this.application_id});
                        this.$store.commit('stage/updateAnswerIds', {stageId: this.stage_key, data: res.data.map(d => ({aid: d.Id, qid: d['Question__c']}))})
                        this.$store.commit('stage/updateStageStatus', {stageId: this.stage_key, status})
                    }
                }, () => this.autoSaving = false)
            }, AUTO_SAVE_INTERVAL);
        },
        validate(showError = false) {
            const result = this.$refs.form.validate();
            if(showError) {
                setTimeout(() => {
                    const el = document.getElementsByClassName('error--text')[0];
                    el && el.scrollIntoView({behavior: 'smooth'});
                }, 0)
            }
            return result;
        },
        async save() {
            // if(!this.validate()) {
            //     return;
            // }
            // this.loading = true;
            clearInterval(this.autoSaveTimer);
            const answers = this.questions;
            const status = this.validate() ? 'Completed' : 'In Progress';
            const client = Client();
            client.post(`/applications/${this.application_id}/stages/${this.stage_key}?status=${status}`, {
                answers: answers.map(a => ({
                    Id: a['Answer__c.Id'],
                    Answer__c: a['Answer__c.Answer__c'],
                    Question__c: a.Id,
                    Scholarship_Application__c: this.application_id
                }))
            }).then(() => {
                // this.$store.dispatch('stage/fetchStages', {appId: this.application_id});
                this.$store.dispatch('stage/fetchQuestionsWithAnswer', {stageId: this.stage_key, appId: this.application_id});
                this.$store.commit('loading/remove', {id: this.stage_key});
                this.$store.commit('stage/updateStageStatus', {stageId: this.stage_key, status})
            }, () => {
                this.$store.commit('loading/remove', {id: this.stage_key});
            })
            // this.loading = false;
            // this.$store.dispatch('stage/fetchStages', {appId: this.application_id});
            // this.$store.dispatch('stage/fetchQuestionsWithAnswer', {stageId: this.stage_key, appId: this.application_id});
            this.$router.push({name: 'application.dashboard'});
            this.$store.commit('loading/push', {id: this.stage_key, message: 'Saving answers...'});
        },
        findChildQuestions(q) {
            const questionsWithAnswer = this.$store.getters['stage/questionsWithAnswer'];
            if(!questionsWithAnswer[this.stage_key]) return [];
            const children = questionsWithAnswer[this.stage_key].filter(d => d.Parent_Question__c && d.Parent_Question__c === q.Id);
            return children;
        },
        updateAnswer({qid, answer}) {
            this.$store.commit('stage/updateAnswer', {stageId: this.stage_key, questionId: qid, answer});
        }
    }
}
</script>
<style lang="scss" scoped>
.helper_text-wrapper {
    text-align: center;
    width: 100%;
    color: $go-dark-grey;
    margin-bottom: 10px;
}

.stage-image-position {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 40px;
}
.stage-title {
    text-align: center;
    font-size: 30px;
    font-weight: 600;
    font-family: $body-font-family;
    margin-bottom: 28px;
}
.font {
    font-family: $secondary-font;
}
.sticky-footer {
    box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.2);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
}
.button {
    width: 100%;
    color: white;
    font-family: $btn-font;
}
.extra-bottom-area {
    margin-bottom: 120px;
}
</style>
